import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { CarrierReportService } from '../../services/carrier-report.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { WorkShiftService } from '../../services/work-shift.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-update-carrier-report',
    templateUrl: './update-carrier-report.component.html',
    styleUrls: ['./update-carrier-report.component.css', '../../app.component.css']
})

export class UpdateCarrierReportComponent implements OnInit, OnDestroy {

    reportForm: FormGroup;
    report: any = [];

    carriers = {};
    carrierInit: any;
    carrierText = '';

    projects = {};
    projectInit: any;
    projectText = '';

    pickadateParams = Utils.pickadateParams();

    id: string;
    reportDate: any;

    employees = {};
    employeeInit: any;
    employeeText = '';

    employeeForm: FormGroup;
    employee: any = [];

    activitiesCapture: number;

    pickatimeParams = Utils.pickatimeParams();

    workShifts: any = [];

    startTime = '01:00';
    endTime = '23:00';
    workShiftVal: string;

    startTimeInit: any;
    endTimeInit: any;

    employeesReport: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Empleado', name: 'employeeName' },
        { title: 'Turno', name: 'workShiftName' },
        { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
              styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['striped'],
        api: {
            onDelete: this.onDelete.bind(this)
        }
    };

    registeredEmployeesNumber = 0;

    gcrSubs: Subscription;
    gpsSubs: Subscription;
    gwsSubs: Subscription;
    geSubs: Subscription;
    gpoSubs: Subscription;
    gerSubs: Subscription;
    paramSub: Subscription;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private carrierReportService: CarrierReportService,
                private employeeService: EmployeeService,
                private productionOrderService: ProductionOrderService,
                private catalogsSettingsService: CatalogsSettingsService,
                private workShiftService: WorkShiftService) {
        this.loadCarriersAndProjects();

        this.paramSub = this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.gcrSubs = this.carrierReportService.getCarrierReport(this.id).subscribe(reportObj => {
                this.gcrSubs.unsubscribe();

                this.report = reportObj[0];

                this.carrierText = this.report.employeeObj.employeeName;
                this.projectText = this.report.productionOrderObj.productionOrderName;
                this.reportDate = Utils.convertDatefromStringtoISOString(this.report.reportDate);
                this.startTimeInit = this.report.startTime;
                this.endTimeInit = this.report.endTime;
                this.startTime = this.startTimeInit;
                this.endTime = this.endTimeInit;

                this.gpsSubs = this.catalogsSettingsService.getPayrollSettings('1').subscribe(payrollObj => {
                    this.gpsSubs.unsubscribe();

                    this.activitiesCapture = payrollObj.activitiesCapture;

                    this.gwsSubs = workShiftService.getWorkShifts().subscribe(tempWorkShifts => {
                        this.gwsSubs.unsubscribe();

                        this.workShifts = tempWorkShifts;
                        this.workShiftVal = this.workShifts[0].id$;
                    });
                });
            });

            this.loadEmployeesReport();
        });
    }

    ngOnInit() {
        this.reportForm = this.formBuilder.group({
            carrier: ['', Validators.required],
            project: ['', Validators.required],
            reportDate: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', [Validators.required]]
        });

        this.employeeForm = this.formBuilder.group({
            employee: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', Validators.required],
            workShift: ['', Validators.required]
        });
    }

    onSubmitReport() {
        this.report = this.saveReport();

        this.carrierReportService.putCarrierReport(this.report, this.id).then(res => {
            this.router.navigate(['/carrier_reports']);
        });
    }

    saveReport() {
        const reportDate = Utils.convertDatefromISOStringtoObject(this.reportForm.get('reportDate').value);

        const reportJson = {
            employeeId: this.carriers[this.reportForm.get('carrier').value],
            endTime: this.reportForm.get('endTime').value,
            productionOrderId: this.projects[this.reportForm.get('project').value],
            reportDate:  reportDate,
            startTime: this.reportForm.get('startTime').value,
            updatedAt: new Date()
        };

        return reportJson;
    }

    loadCarriersAndProjects() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const dataEmployee = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.carriers[employeeDisplayValue] = tempEmployees[idx].id$;
                this.employees[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.carrierInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.carriers[val]);
                }
            };

            this.employeeInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.employees[val]);
                }
            };
        });

        this.gpoSubs = this.productionOrderService.getProductionOrders().subscribe(tempProjects => {
            const dataProject = {};

            for (const idx in tempProjects) {
                dataProject[tempProjects[idx].name] = null;
                this.projects[tempProjects[idx].name] = tempProjects[idx].id$;
            }

            this.projectInit = {
                'data': dataProject,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.projects[val]);
                }
            };
        });
    }

    onBlurCarrier() {
        if (this.carriers[this.carrierText] === undefined) {
            this.carrierText = '';
        }
    }

    onBlurProject() {
        if (this.projects[this.projectText] === undefined) {
            this.projectText = '';
        }
    }

    onBlurEmployee() {
        if (this.employees[this.employeeText] === undefined) {
            this.employeeText = '';
        }
    }

    onSubmitEmployee() {
        this.employee = this.saveEmployee();

        this.carrierReportService.postEmployeeReport(this.employee, this.id).then(res => {
            this.employeeText = '';
            this.startTime = this.startTimeInit;
            this.endTime = this.endTimeInit;
            this.workShiftVal = this.workShifts[0].id$;

            this.loadEmployeesReport();
        });
    }

    saveEmployee() {
        const currentDate = new Date();

        const employeeJson = {
            activitiesCapture: this.activitiesCapture,
            createdAt: currentDate,
            employeeId: this.employees[this.employeeForm.get('employee').value],
            endTime: this.employeeForm.get('endTime').value,
            employeeName: this.employeeForm.get('employee').value,
            startTime: this.employeeForm.get('startTime').value,
            updatedAt: currentDate,
            workShiftId: this.employeeForm.get('workShift').value,
            workShiftName: this.workShifts.filter(x => x.id$ === this.employeeForm.get('workShift').value)[0].name
        };

        return employeeJson;
    }

    onDelete(data: any) {
        this.deleteEmployeeReport(data.row.id$);
    }

    deleteEmployeeReport(id$) {
        this.carrierReportService.delEmployeeReport(id$, this.id).then(res => {
            this.loadEmployeesReport();
        });
    }

    loadEmployeesReport() {
        this.gerSubs = this.carrierReportService.getEmployeesReport(this.id).subscribe(tempEmployeesReport => {
            this.employeesReport = [];

            for (const idx in tempEmployeesReport) {
                this.employeesReport.push(tempEmployeesReport[idx]);
            }

            this.data = this.employeesReport;
            this.length = this.data.length;
            this.onChangeTable(this.config);

            this.registeredEmployeesNumber = this.data.length;
        });
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
        this.gpoSubs.unsubscribe();
        this.gerSubs.unsubscribe();
        this.paramSub.unsubscribe();
    }



    // *************** Table functionality *************** //
     changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
